import { defineNuxtPlugin } from "#app";
import "reflect-metadata";

export default defineNuxtPlugin(() => {
  /**
   * @note
   * OpenTelemetry SDK using process.env for check env vars.
   */
});
